<template>
	<div id="app" @mousemove ="setOutTime">
		<div class="topNav" :class="setBackgroundColor($PayNameImg)" v-if="!this.$route.meta.noNav">
			<div class="navbar flexX flexcenter">				
				<div class="logo">
					<span> 卡密核销系统</span>					
				</div>				
			</div>


			<div class="topNavHeader">	
				<el-dropdown trigger="click" class="mr20">
					<div class="msg-btn">
						<el-badge :hidden="!ckData.total || ckData.total.total == 0" :value=" ckData.total ? ckData.total : ''" class="item" >
							<span class="msg-icon-btn" ><i class="f18 el-icon-bell"></i></span>
						</el-badge>
					</div>
					
					<el-dropdown-menu slot="dropdown">
						<div class="flexX message-center-box" >     
							<CKDialog :dialogVisible = "ckData.visible" :ckList="ckData.allCKList"></CKDialog>     
						</div>
					</el-dropdown-menu>
				</el-dropdown>		


				<div>				
					<span class="flexX mr20 username flexcenter pointer">
						<el-dropdown @command="handleCommand($event)">
							<span class="el-dropdown-link">
								{{getusername}} <i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="logout">退出登录</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</span>			
					
				</div>
			</div>
			
		</div>
		<div class="bottomMain" v-if="!this.$route.meta.noNav">
			<div class="sideBox" :class="[{sideHiden:showSide==='hide',sideShow:showSide==='show'}, setBackgroundColor($PayNameImg)]">
				<div v-if="nav.length>0">
					<div v-for="(item,index) in nav"  :key="index" class="itemBox firstItemBox">
						<div class="navItem firstNav show pageNav" :class="{active:nowPath.includes(item.path) && item.meta.islink,childActive:item.meta.id == parentId}" @click="gotopage(item,index,'showOne')">
							<span><span :class="item.meta.icon" class="fs18"></span> {{item.meta.title}}</span>
							<span v-if="!item.meta.islink" class="clildIcon" :class="{'el-icon-arrow-down':!(show.showOne===index),'el-icon-arrow-up':(show.showOne === index)}"></span>
							<!-- <div v-else class="active-right"></div> -->
						</div>
						<div v-if="item.children && item.children.length > 0" class="childNav">
							<div v-for="(item2,index2) in item.children" :key="index2" class="itemBox">
								<div class="navItem twotNav pageNav" :class="{active:nowPath.includes(item2.path) && item2.meta.islink,ractive:show.showTwo===index2 && !item2.meta.islink,show:show.showOne === index}" @click="gotopage(item2,index2,'showTwo')">
									<span><span :class="item2.meta.icon" class="fs18"></span> {{item2.meta.title}}</span>
									<span v-if="!item2.meta.islink" class="clildIcon" :class="{'el-icon-arrow-up':show.showTwo!=index2}"></span>
									<!-- <div v-else class="active-right"></div> -->
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
			

			<div class="main-container" :class="{noSide:showSide==='hide',hasSide:showSide==='show',hasThreeDic:threeDirectory.length > 0}">
				<router-view />
			</div>
		</div>
		<div class="loginMain" v-if="this.$route.meta.noNav">
			<!-- 登录 -->
			<router-view />
		</div>
		<div class="app-dialog-box">
			<!-- ck失效提示弹窗 -->
			 
		</div>
	</div>
</template>
<script>
	import local from './util/local.js'
	import CKDialog from '@/components/CKDialog.vue'
	export default {
		name: 'Home',
		components: {
			CKDialog
		},
		computed:{
			// getusername(){
			// 	return local.get("username")
			// }
		},
		data() {
			return {
				nav: [],
				show: {
					showOne: '',
					showTwo: '',
					showThree: ''
				},
				showSide: '', //是否显示左边导航
				nowPath: '',
				threeDirectory: [],
				ParentDirector: [],
				username: '',
				tid: '',
				parentId:'',
				outTime :'',
				getusername:'',
				ckData:{
					total:0,
					allCKList:[],
					newCKList:[],
					visible:false,
					setInterval:null,
					setIntervalTime:6000,
				}
				
			}
		},
		beforeDestroy() {
            //清除定时器
		},
		created() {
			this.username = local.get("username")
			this.tid = local.get("tid")			
			this.getNav()
			this.nowPath = this.$route.path
			// this.getBreadCrumb()
		},
		mounted() {
			this.getusername = local.get("username")
			//整个网站任意页面都需请求的接口(除登录页面外的正常页面)
			if(!this.$route.meta.noNav){				
				this.getInvalidCkList()
			}
			clearInterval(this.ckData.setInterval)
			this.ckData.setInterval = setInterval(()=>{
				if(!this.$route.meta.noNav){
					this.getInvalidCkList()
				}			
			},this.ckData.setIntervalTime)
			
			
		},
		methods: {
			
			setOutTime(){

				this.$outTime = 24*60*60
				// this.$outTime = 5

			},
			setBackgroundColor(name){
				if(name == 'wanding'){
					return "wanding"
				}else if(name == 'laike-YL'){
					return "laike-YL"
				}else{
					return "default"
				}
				
			},
			language(val){
				this.$i18n.locale = val
				localStorage.setItem("lang", val)
			},	
			getNav() {
				//重新获取用户名  登录成功后会调用此方法  以便重置用户名 和 目录
				this.getusername = local.get("username") 
				let routes = this.$router.options.routes;
				let manage = this.$local.get('manage')
				if(manage){
					//管理员 
					let routes = this.$router.options.routes;
					for(let i = 0; i< routes.length; i++){
						routes[i].directory = true
					}
				}else{
					//非管理员  只保留仪表盘和重置密码
					let routes = this.$router.options.routes;
					for(let i = 0; i< routes.length; i++){
						routes[i].directory = false
						if(routes[i].name == 'Dashboard' || routes[i].name == 'Setting' || routes[i].name == 'ResetPassword'){
							routes[i].directory = true
						}
					}
				}
				let navAll = routes.filter(item => {
					if (item.directory) {
						return item
					}
				})
				let navArr = []
				for (let i = 0; i < navAll.length; i++) {
					if (navAll[i].meta.parentId === 0) {
						navAll[i].children = []
						navArr.push(navAll[i])
						navAll.splice(i, 1)
						i = i - 1
					}
				}
				for (let i = 0; i < navAll.length; i++) {
					if (navAll[i].meta.parentId != 0 && navAll[i].meta.leven === 1) {
						for (let j = 0; j < navArr.length; j++) {
							if (navAll[i].meta.parentId === navArr[j].meta.id) {
								navAll[i].children = []
								navArr[j].children.push(navAll[i])
							}
						}
					}
				}
				
				this.nav = navArr
			},
			gotopage(item, index, showNum) {							
				if (this.showSide == 'show') {
					this.showSide = ""
				}
				this.showChildren(index, showNum, item.meta.islink)
				if (this.$route.path === item.path && item.meta.islink) {
					this.$router.push({
						path: '/replace'
					})
					return
				}
				if (item.meta.islink) {
					this.$router.push(item.path)
				}
				
			},
			toggleClick() {
				if (this.showSide === 'hide') {
					this.showSide = 'show'
				} else {
					this.showSide = 'hide'
				}
			},
			showChildren(index, showNum, islink) {
				if (showNum === 'showOne') {
					this.show.showTwo = ''
				}
				if (this.show[showNum] === index) {
					if (!islink) {
						this.show[showNum] = ''
					}
				} else {
					this.show[showNum] = index
				}
			},
			showDataAll(){
				if (this.$route.path === 'index') {
					this.$router.push({
						path: '/replace'
					})
					return
				}
				this.threeDirectory = []
				this.$router.push('/index')
			},
			setPassword(){
				//重置密码
				this.$router.push('./resetPassword')
			},
			logout(){
				//登出
				let data = {
                    username:this.$local.get('username')
                }
                this.$api.logout(data).then(res=>{
					if(res.status == 1){
						this.$local.remove('tid')
						this.$local.remove('username')
						this.$router.push('./login')
					}                    
                    if(res.status !=1){
                        Message({
                            message:res.msg,
                            type:"error",
                            duration: 3 * 1000
                        })
                    }
                })
			},
			handleCommand(command){
				this[command]()
			},
			//获取失效ck列表 （用于弹窗提醒） 接口
			async getInvalidCkList(){
				let res = await this.$api.getInvalidCkList({})				
				if(res.status == 1){
					this.ckData.total = res.data.total
					this.ckData.allCKList = res.data.list
					let newCKlist = JSON.parse(JSON.stringify(res.data.list))
					let localCKList = this.$local.get('ckList');
					this.$local.set('ckList',newCKlist);
					let ckList = JSON.parse(JSON.stringify(newCKlist))
					if(localCKList){
						for(let i = 0; i < newCKlist.length; i++){
							let newCKItem = newCKlist[i]
							for(let j = 0; j < localCKList.length; j++){
								let localCKItem = localCKList[j]
								if(newCKItem.ck_id == localCKItem.ck_id){
									for(let k = 0; k < ckList.length; k++){
										if(ckList[k].ck_id == newCKItem.ck_id){
											ckList.splice(k,1)
										}
									}
									
								}
							}
							
						}
					}
					this.ckData.newCKList = JSON.parse(JSON.stringify(ckList))
					if(this.ckData.newCKList.length > 0){
						let msg = ''
						for(let i = 0; i < this.ckData.newCKList.length; i++){
							let item = this.ckData.newCKList[i]
							msg += `<div class="ck-item"> 
										<span class="ck-trader">${item.trader_name}</span>
										<span class="ck-value">${item.ck_name}</span>
										<span class="ck-status">已失效</span>
									</div>`
						}
						this.$notify({
							title: '已失效ck',
							duration: 0,
							dangerouslyUseHTMLString: true,
							message: msg,
							customClass:'ck-notify'
						});
						// this.$notify({
						// 	title: '已失效ck',
						// 	message: '这是一条不会自动关闭的消息',
							
						// });
						// this.ckData.visible = true
						// clearInterval(this.ckData.setInterval)
					}
				}
				// return res
			},
			
		},
		watch: {
			$route(to, from) {
				this.nowPath = this.$route.path
				for(let i = 0;i < this.$router.options.routes .length;i++){
					let item = this.$router.options.routes[i]
					if(item.path == this.nowPath){
						this.parentId = item.meta.parentId
					}
				}
				if(this.outTime){
					clearInterval(this.outTime)	
				}	
				if(to.path != '/login' && to.path != '/'){		
					this.outTime = setInterval(() => {
						this.$outTime = this.$outTime - 1*30
						if(this.$outTime <=0){
							local.remove("username")
							local.remove("tid");
							local.remove("is_first_login")
							this.$router.push('./login')
							clearInterval(outTime)
							this.logout()
						}
						console.log(this.$outTime,to.path,'to 剩余事件')
					}, 30000);
				}
			},
		
		}
	}
</script>


<style lang="scss">

	@import '@/style/variables.scss';
	* {
		padding: 0;
		margin: 0;
	}
	.my-poper-class{
		background: #4d4d4d !important;
		color: #fff !important;
		border: 1px solid #4d4d4d !important;
	}
	.my-poper-class .popper__arrow::after {
		border-bottom-color: #4d4d4d !important;
	}
	.my-poper-class .popper__arrow {
		border-bottom-color: #4d4d4d !important;
	}
	.popver-item{
		padding: 8px;
		text-align: center;
		cursor: pointer;
	}

	.wanding{
		background: #16222A;  /* fallback for old browsers */
		background: -webkit-linear-gradient(to bottom, #3A6073, #16222A);  /* Chrome 10-25, Safari 5.1-6 */
		background: linear-gradient(to bottom, #3A6073, #16222A); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

	}
	.laike-YL{
		background: #16222A;  /* fallback for old browsers */
		background: -webkit-linear-gradient(to top, #3A6073, #16222A);  /* Chrome 10-25, Safari 5.1-6 */
		background: linear-gradient(to top, #3A6073, #16222A); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

	}
	
	.usdtCss{
	   color: #909399;
	   font-size: xx-small;
   	}
	#app {
		// font-family: Avenir, Helvetica, Arial, sans-serif;
		font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		// text-align: center;
		color: #101010;
		font-size: 16px;
	}
	.el-table--mini {
	    font-size: 0.735vw;
	}

	#nav {
		padding: 30px;
	}

	.topNav {
		height: 60px;
		// background-color: $menuBg;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 99;
		width: 100%;
		display: flex;
		align-items: center;
		// justify-content: space-between;
		padding-right: 20px;
		border-bottom: 1px solid #e6e6e6;
		&.default{
			background: #fff;  /* fallback for old browsers */
		}
		.topNavHeader{
			display: flex;
			justify-content: flex-end;
			flex: 1;
			>div:first-child{
				color: #fff;
				display: flex;
				align-items: center;
				.money{
					margin-top: 3px;
				}
				>div{
					display: flex;
					margin-right: 20px;
					align-items: center
				}
			}
			.el-dropdown-link {
				cursor: pointer;
				color: #409EFF;
			}
			.el-icon-arrow-down {
				font-size: 12px;
			}
			.msg-btn{
                padding: 8px;
                border-radius: 4px;
                color: #606266;
                &:hover {
                    background-color: #f5f5f5;
                    color:#3377FF;
                }
                .msg-icon-btn{
                    cursor: pointer;
                    transition: background-color .3s;
                    display: inline-flex;
                    line-height: 1;
                    position: relative;
                    vertical-align: top;
                    &.shake{
                        animation: sway 0.5s ease-in-out infinite;
                        will-change: transform;
                    }
                }
                /* 关键帧：左右平滑摆动 */
                @keyframes sway {
                    0%, 100% {
                        transform: rotate(0);
                    }
                    25% {
                        transform: rotate(-10deg);
                    }
                    75% {
                        transform: rotate(10deg);
                    }
                }
            }
          
		}
		.username {
			color: $navColor;	
			
		}
	}

	.hamburger {
		display: inline-block;
		vertical-align: middle;
		width: 20px;
		height: 20px;
	}

	.hamburger .icon {
		background-color: transparent;
		border-bottom: 20px solid $warning;
		border-right: 20px solid transparent;
		transform: rotate(45deg);
	}

	.hideSidebar .hamburger .icon {
		background-color: transparent;
		border-bottom: 20px solid $warning;
		border-right: 20px solid transparent;
		transform: rotate(-135deg);
	}

	.hamburger.is-active {
		transform: rotate(180deg);
	}

	.sideBox {
		color: $navColor;
		text-align: left;


		.itemBox {
			padding-left: 18px;
			cursor: pointer;



			&.firstItemBox {
				padding-left: 0;

			}

			.childNav {
				// background-color: $subMenuBg;
				// font-size: 18px;
				.itemBox{
					padding-left: 0px;
					.navItem{
						padding-left: 41px;
					}
				}
			}

			.navItem {
				padding: 8px 20px;
				display: none;
				height:56px;
				align-items: center;
				justify-content: space-between;

				&.twotNav {
					// font-size: 0.68vw;
					// color: $navSubColor;
					// padding-left: 12px;
				}

				&.firstNav {
					// border-bottom: 1px solid rgba(107, 108, 109, 0.19);

				}

				&.show {
					display: flex;
				}

				&.active {
					color: #1684fc;
					// background:#e6f7ff;
					position:relative;
					.active-right{
						position: absolute;
						right: 0;
						height:100%;
						width: 4px;
						background: $primary;
					}
				}
				&:hover{
					background:#ecf5ff;
				}

				&.ractive {
					color: #f5f5f5;
				}
				&.childActive{
					color: #1684fc;
				}
				.clildIcon{
					font-weight: 600;
				}
			}
		}

	}

	.threeDirectoryBox {
		.threeChildNav {
			display: flex;
			height: 40px;
			background-color: $threeNavbackColor;
			align-items: center;
			 box-sizing: border-box;
			 margin: 10px 10px 0;
			 border: 1px solid #ddd;
			.itemBox {
				// margin-right: 20px;
				padding: 0 10px;
				height: 100%;
				display: flex;
				align-items: center;
				border-bottom: solid 2px rgba(0, 0, 0, 0);
				cursor: pointer;
				margin-bottom: -1px;
				&.active {
					color: $primary;
					background: #fff;
					border-left: solid 1px $tableBorderColor;
					border-right: solid 1px $tableBorderColor;
				}
				&:first-child.active{
					border-left:none
				}
			}
		}
	}
	
	.activeClass {
		color: $warning;
	}

	.loginMain {
		min-height: 100vh;
	}
	
	//  .el-dropdown-link {
	//     cursor: pointer;
	//     color: #409EFF;
	//     font-size: 18px;
	//   }
	.ck-notify{
		.el-notification__content{
			// width: 500px;
		}
		.ck-item{
			display: flex;
			overflow: auto;
			font-size: 12px;
			.ck-trader{
				color:#303133;
				font-size: 14px;
				font-weight: 600;
			}
			.ck-value{
				color:#606266;
				margin-right: 5px;
			}
			.ck-status{
				color:#E6A23C;
			}
		}
	}
	
</style>
